// Definición de defaults

export const defaultTipoIdentificacion: TipoIdentificacionProps = {
    idTipoIdentificacion:   0,
    descripcion:            '',
    activo:                 false,
}

// Creación de interfaces

export interface TipoIdentificacionProps   {
    idTipoIdentificacion:   number;
    descripcion:            string;
    activo:                 boolean;
}